import { styled } from '@volkswagen-onehub/components-core';
import zIndex from '@/modules/constants/zIndex';
import type { BreakpointsProps } from '@/types';
import {
  convertBreakpointsToMediaQueries,
  jssToCss,
} from '@/modules/utils/themeUtils';
import { VWIMAGE_SIZES, VWImageQuality } from '..';

interface StyledSliderProps extends BreakpointsProps<StyledSliderProps> {
  offsetTop?: number;
  width?: string;
  height?: string;
}

//slick slider 1.6.0
const slickStyles = `.slick-list,.slick-slider,.slick-track{position:relative;display:block}.slick-loading .slick-slide,.slick-loading .slick-track{visibility:hidden}.slick-slider{box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}.slick-list{overflow:hidden;margin:0;padding:0}.slick-list:focus{outline:0}.slick-list.dragging{cursor:pointer;cursor:hand}.slick-slider .slick-list,.slick-slider .slick-track{-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);-o-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.slick-track{top:0;left:0}.slick-track:after,.slick-track:before{display:table;content:''}.slick-track:after{clear:both}.slick-slide{display:none;float:left;height:100%;min-height:1px}[dir=rtl] .slick-slide{float:right}.slick-slide img{display:block}.slick-slide.slick-loading img{display:none}.slick-slide.dragging img{pointer-events:none}.slick-initialized .slick-slide{display:block}.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent}.slick-arrow.slick-hidden{display:none}`;

export const StyledSliderWrapper = styled.div<StyledSliderProps>(
  ({ theme, width, height, offsetTop, ...restProps }) => `
  ${jssToCss({
    width,
    height,
  })}

  ${slickStyles};

  .slick-list {
    overflow: hidden;
    max-height: calc(100vh - ${offsetTop}px);
  }

  .slick-arrow {
    display: none;
  }

  .slick-next {
    right: ${theme.size.static520};
  }

  .slick-prev {
    left: ${theme.size.static520};
  }

  .slick-slide img {
    object-fit: contain;
  }

  .slick-dots {
    margin: ${theme.size.static350};
    padding: 0;
    list-style-type: none;
    text-align: center;

    li {
      position: relative;
      display: inline-block;
      margin: 0 2px;
      height:  100%;
      width: ${theme.size.static150};


      > * {
        font-size: 0;
        width: 100%;
        height: 100%;
        padding: 0;
        position: absolute;
      }

      &.slick-active {
        transform: scale(2.2);
      }

      :before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        border-radius: 50%;
        background: ${theme.colors.button.primary.default};
        transform: translate(-50%, -50%);
        height: ${theme.size.static100};
        width: ${theme.size.static100};
      }
    }
  }

  .slick-dots {
    position: absolute;
    flex-grow: 1;
    width: 100%;
  }

  .slick-slide > div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }

  .slick-slide img {
    max-width: ${VWIMAGE_SIZES[VWImageQuality.HIGH]}px;
  }

  ${convertBreakpointsToMediaQueries({
    b960: `
      .slick-arrow {
        position: absolute;
        bottom: ${theme.size.static515};
        z-index: ${zIndex.FOREGROUND};
      }

      .slick-dots {
        background: ${theme.colors.background.primary};
        border-radius: calc(${theme.size.static350} / 2);
        padding: 0 ${theme.size.static300};
        height: ${theme.size.static350};
        left: 50%;
        transform: translateX(-50%);
        bottom: ${theme.size.static520};
        margin: 0;
        width: auto;
      }

      .slick-slide img {
        height: 100%;
      }
    `,
  })};

  ${convertBreakpointsToMediaQueries(restProps)};
`
);

export const StyledSliderArrow = styled.div(
  ({ theme }) => `
  > * {
    border: none;
    background: ${theme.colors.background.primary};
  }
`);
